import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Text, TextPlaceholder } from '@gandi/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "table": "OrderTotal-table_2v3e9",
  "number": "OrderTotal-number_3NvPj",
  "grandTotal": "OrderTotal-grandTotal_1BIyz"
};
export default function OrderTotal({
  currency,
  priceBeforeTaxes,
  priceAfterTaxes,
  taxes
}) {
  const {
    __,
    formatPrice
  } = useTranslator();

  // use <table> to present tabular data.
  return /*#__PURE__*/_jsx("table", {
    summary: __('Order total'),
    className: styles.table,
    children: /*#__PURE__*/_jsxs("thead", {
      children: [/*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("td", {
          children: __('Subtotal')
        }), /*#__PURE__*/_jsx("td", {
          className: styles.number,
          children: formatPrice(priceBeforeTaxes, currency)
        })]
      }), taxes.map(tax => /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsxs("td", {
          children: [__('Sales Taxes'), ' ', /*#__PURE__*/_jsxs(Text, {
            color: "light",
            children: [tax.name_label, " ", tax.rate, "%"]
          })]
        }), /*#__PURE__*/_jsx("td", {
          className: styles.number,
          children: tax.amount ? formatPrice(tax.amount, currency) : /*#__PURE__*/_jsx(TextPlaceholder, {})
        })]
      }, `tax-${tax.type_label}`)), /*#__PURE__*/_jsxs("tr", {
        className: styles.grandTotal,
        children: [/*#__PURE__*/_jsx("td", {
          children: __('Total')
        }), /*#__PURE__*/_jsx("td", {
          className: styles.number,
          children: formatPrice(priceAfterTaxes, currency)
        })]
      })]
    })
  });
}